import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/utils";

/**
 * ScrollArea
 *
 * A vertically scrollable region using the app's native styled scrollbars
 * (see `globals.css`). Kept as a thin wrapper so scroll behaviour is
 * consistent everywhere and can later be swapped for a virtualised
 * implementation without touching call sites.
 */
export interface ScrollAreaProps extends HTMLAttributes<HTMLDivElement> {
  /** Fade the top/bottom edges to hint at overflow. */
  fadeEdges?: boolean;
}

export const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ fadeEdges = false, className, children, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "relative h-full overflow-y-auto overflow-x-hidden",
        fadeEdges &&
          "[mask-image:linear-gradient(to_bottom,transparent,black_16px,black_calc(100%-16px),transparent)]",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);

ScrollArea.displayName = "ScrollArea";
